import './Item.css';const item__row = "_item__row_4tulk_1";
const item__singleTable = "_item__singleTable_4tulk_38";
const item__label = "_item__label_4tulk_43";
const item__value = "_item__value_4tulk_53";
const item__icon = "_item__icon_4tulk_63";
const styles = {
  item__row,
  item__singleTable,
  item__label,
  item__value,
  item__icon,
  "item__icon--minus": "_item__icon--minus_4tulk_75",
  "item__icon--check": "_item__icon--check_4tulk_78"
};
export {
  styles as default,
  item__icon,
  item__label,
  item__row,
  item__singleTable,
  item__value
};
